import type { ModelsResolver } from "@/models/resolvers";
import { revisionDefaultFields } from "@/models/resolvers";
import { useLogger } from "@/composables/logger";
import { useCacheOperations } from "@/composables/cache";

const { info: logInfo } = useLogger("INTAKES_XREF_RESOLVER");

export default {
  queries: {
    scenario_equipment_xref_intakes: {
      intake: (parent, args, cache, info) => {
        return parent.intake_id
          ? { __typename: "intakes", id: parent.intake_id }
          : null;
      }
    }
  },
  optimistic: {
    insert_revisions_scenario_equipment_xref_intakes_revisions(
      vars,
      cache,
      info
    ) {
      logInfo("Optimistic", { vars, cache, info });
      return {
        __typename:
          "revisions_scenario_equipment_xref_intakes_revisions_mutation_response",
        returning: vars.objects.map(object => ({
          id: object.id,
          __typename: "revisions_scenario_equipment_xref_intakes_revisions",
          scenario_equipment_xref_intakes_view: {
            __typename: "scenario_equipment_xref_intakes",
            ...object,
            ...revisionDefaultFields(object),
            intake: null
          }
        }))
      };
    }
  },
  updates: {
    insert_revisions_scenario_equipment_xref_intakes_revisions(
      result,
      args,
      cache,
      info
    ) {
      logInfo("Mutation", { result, args, cache, info });

      args.objects.forEach(object => {
        const { handleCacheUpdate } = useCacheOperations({
          cache,
          object,
          typename: "scenario_equipment_xref_intakes"
        });

        handleCacheUpdate([
          {
            args: {
              where: {
                journal_deleted_at: {
                  _is_null: true
                }
              }
            },
            relatedCacheKey: cache.keyOfEntity({
              __typename: "scenario_equipment",
              id: object.scenario_equipment_id
            }),
            relatedField: "xref_intakes"
          }
        ]);
      });
    }
  }
} as ModelsResolver;
